
import {useSignIn} from "../use-sign-in";

export default function Callback(){
   const {useOnAuthStateChange} = useSignIn();
   useOnAuthStateChange();
   return null;
}
